// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-col {
  padding: 0;
}

/* ============================================
   BUTTON STYLES
   ============================================ */
.btn-primary {
  background-color: #27405f;
  border: 1px solid #27405f;
  font-weight: 600;
  text-align: center;
  color: white;
  height: 40px;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.btn-primary:hover {
  background-color: #1d3049;
  border-color: #1d3049;
}

.btn-primary:disabled {
  background-color: #e9ecef;
  border-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
}

/* ============================================
   LEGACY MENUBAR OVERRIDES (for backwards compat)
   ============================================ */
.ui-menubar-overide,
.ui-menubar-custom {
  background: #27405f !important;
  border: none !important;
  padding: 0 !important;
  border-radius: 0 !important;
}

.ui-menubar-custom .ui-menuitem-text-custom,
.ui-menuitem-link-custom .ui-menuitem-text-custom {
  font-weight: bold;
  color: #fff;
}

.ui-menubar-custom .ui-menuitem-text-custom .ui-menuitem-link-custom,
.ui-menuitem-link-custom {
  text-decoration: none;
  color: #fff;
  background: none !important;
  padding: 1em !important;
  border-radius: 0;
}

/* ============================================
   TOAST/GROWL MESSAGE STYLES (PrimeNG 19)
   ============================================ */
:host ::ng-deep .p-toast-message.p-toast-message-info,
:host ::ng-deep .ui-growl-item-container.ui-state-highlight.ui-growl-message-info {
  background-color: #d0e1fd !important;
  color: #004085 !important;
  border: solid #0070d2 !important;
  border-width: 0 0 0 6px !important;
}

:host ::ng-deep .p-toast-message.p-toast-message-error,
:host ::ng-deep .ui-growl-item-container.ui-state-highlight.ui-growl-message-error {
  background-color: #f8d7da !important;
  color: #721c24 !important;
  border: solid #dc3545 !important;
  border-width: 0 0 0 6px !important;
}

:host ::ng-deep .p-toast-message.p-toast-message-warn,
:host ::ng-deep .ui-growl-item-container.ui-state-highlight.ui-growl-message-warn {
  background-color: #ffecb5 !important;
  color: #856404 !important;
  border: solid #ffc107 !important;
  border-width: 0 0 0 6px !important;
}

:host ::ng-deep .p-toast-message.p-toast-message-success,
:host ::ng-deep .ui-growl-item-container.ui-state-highlight.ui-growl-message-success {
  background-color: #c8e6c9 !important;
  color: #155724 !important;
  border: solid #28a745 !important;
  border-width: 0 0 0 6px !important;
}

/* ============================================
   LEGACY UI BUTTON STYLES (PrimeNG 19)
   ============================================ */
:host ::ng-deep .ui-button-text-only .ui-button-text,
:host ::ng-deep .p-button .p-button-label {
  font-weight: 600;
}

/* ============================================
   APP LAYOUT
   ============================================ */
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-content {
  flex: 1;
  padding: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACC,UAAA;AACD;;AAEA;;iDAAA;AAGA;EACC,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,oDAAA;AACD;;AAEA;EACC,yBAAA;EACA,qBAAA;AACD;;AAEA;EACC,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;AACD;;AAEA;;iDAAA;AAGA;;EAEC,8BAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;AACD;;AAEA;;EAEC,iBAAA;EACA,WAAA;AACD;;AAEA;;EAEC,qBAAA;EACA,WAAA;EACA,2BAAA;EACA,uBAAA;EACA,gBAAA;AACD;;AAEA;;iDAAA;AAGA;;EAEC,oCAAA;EACA,yBAAA;EACA,gCAAA;EACA,kCAAA;AACD;;AAEA;;EAEC,oCAAA;EACA,yBAAA;EACA,gCAAA;EACA,kCAAA;AACD;;AAEA;;EAEC,oCAAA;EACA,yBAAA;EACA,gCAAA;EACA,kCAAA;AACD;;AAEA;;EAEC,oCAAA;EACA,yBAAA;EACA,gCAAA;EACA,kCAAA;AACD;;AAEA;;iDAAA;AAGA;;EAEC,gBAAA;AACD;;AAEA;;iDAAA;AAGA;EACC,iBAAA;EACA,aAAA;EACA,sBAAA;AACD;;AAEA;EACC,OAAA;EACA,aAAA;AACD","sourcesContent":[".p-col {\n\tpadding: 0;\n}\n\n/* ============================================\n   BUTTON STYLES\n   ============================================ */\n.btn-primary {\n\tbackground-color: #27405f;\n\tborder: 1px solid #27405f;\n\tfont-weight: 600;\n\ttext-align: center;\n\tcolor: white;\n\theight: 40px;\n\tpadding: 0.5rem 1.5rem;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\ttransition: background-color 0.2s, border-color 0.2s;\n}\n\n.btn-primary:hover {\n\tbackground-color: #1d3049;\n\tborder-color: #1d3049;\n}\n\n.btn-primary:disabled {\n\tbackground-color: #e9ecef;\n\tborder-color: #e9ecef;\n\tcolor: #6c757d;\n\tcursor: not-allowed;\n}\n\n/* ============================================\n   LEGACY MENUBAR OVERRIDES (for backwards compat)\n   ============================================ */\n.ui-menubar-overide,\n.ui-menubar-custom {\n\tbackground: #27405f !important;\n\tborder: none !important;\n\tpadding: 0 !important;\n\tborder-radius: 0 !important;\n}\n\n.ui-menubar-custom .ui-menuitem-text-custom,\n.ui-menuitem-link-custom .ui-menuitem-text-custom {\n\tfont-weight: bold;\n\tcolor: #fff;\n}\n\n.ui-menubar-custom .ui-menuitem-text-custom .ui-menuitem-link-custom,\n.ui-menuitem-link-custom {\n\ttext-decoration: none;\n\tcolor: #fff;\n\tbackground: none !important;\n\tpadding: 1em !important;\n\tborder-radius: 0;\n}\n\n/* ============================================\n   TOAST/GROWL MESSAGE STYLES (PrimeNG 19)\n   ============================================ */\n:host ::ng-deep .p-toast-message.p-toast-message-info,\n:host ::ng-deep .ui-growl-item-container.ui-state-highlight.ui-growl-message-info {\n\tbackground-color: #d0e1fd !important;\n\tcolor: #004085 !important;\n\tborder: solid #0070d2 !important;\n\tborder-width: 0 0 0 6px !important;\n}\n\n:host ::ng-deep .p-toast-message.p-toast-message-error,\n:host ::ng-deep .ui-growl-item-container.ui-state-highlight.ui-growl-message-error {\n\tbackground-color: #f8d7da !important;\n\tcolor: #721c24 !important;\n\tborder: solid #dc3545 !important;\n\tborder-width: 0 0 0 6px !important;\n}\n\n:host ::ng-deep .p-toast-message.p-toast-message-warn,\n:host ::ng-deep .ui-growl-item-container.ui-state-highlight.ui-growl-message-warn {\n\tbackground-color: #ffecb5 !important;\n\tcolor: #856404 !important;\n\tborder: solid #ffc107 !important;\n\tborder-width: 0 0 0 6px !important;\n}\n\n:host ::ng-deep .p-toast-message.p-toast-message-success,\n:host ::ng-deep .ui-growl-item-container.ui-state-highlight.ui-growl-message-success {\n\tbackground-color: #c8e6c9 !important;\n\tcolor: #155724 !important;\n\tborder: solid #28a745 !important;\n\tborder-width: 0 0 0 6px !important;\n}\n\n/* ============================================\n   LEGACY UI BUTTON STYLES (PrimeNG 19)\n   ============================================ */\n:host ::ng-deep .ui-button-text-only .ui-button-text,\n:host ::ng-deep .p-button .p-button-label {\n\tfont-weight: 600;\n}\n\n/* ============================================\n   APP LAYOUT\n   ============================================ */\n.app-container {\n\tmin-height: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.app-content {\n\tflex: 1;\n\tpadding: 1rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
